/**
 *
 *
 * @export handlePerChange 左上角操作区变动时计算单页映射进stage的scale
 * @param stageInitScale pageItem内Stage自适应宽度后保存的缩放比例 对应左上角操作区域的50 -> 0.5
 * @param perScale 左上角操作区域当前数值
 */
export function handlePerChange(stageInitScale, perScale) {
    return (stageInitScale / 0.5) * perScale
}
